<template>
  <div class="bg-dark">

    <v-parallax
      dark
      src="/cosmic-background-1.jpg"
    >
    <v-row 
      align="center"
      justify="center"
        >
      <v-col class="text-center" cols="12">
        <h1 class="display-2 font-weight-thin mb-4 mt-12">{{ title }}</h1>
        <p class="font-weight-light subtitle-1">{{ subtitle }}</p>
      </v-col>
    </v-row>
     </v-parallax>
  
       <v-row
        class="bg-dark ml-2 mr-2"
        align="stretch"
        justify="space-around"
        >
      <v-col class="text-center" cols="12">
        <h2 class="display-1 font-weight-light accent-color" dark>{{ skillset.title }}</h2>
      </v-col>
      <!--
      <v-col class="text-center" v-for="section in skillset.sections" :key="section.title">
        <v-card height="100%" >
        
          <v-card-title class="justify-center">
            <div>
              <v-icon color="#FFC300" medium>{{ section.icon }}</v-icon>
              <h4 class="text-center font-weight-light title">{{ section.title }}</h4>
            </div>
          </v-card-title>

          <v-card-text >
            <v-list class="transparent">
              <v-list-item
                v-for="skill in section.items"
                :key="skill.name"
              >
                <v-list-item-content>
                      <v-chip outlined text-color="charcoal" color="#DAF7A6">
                      <v-list-item-title class="text-center font-weight-light " v-text="skill.name"></v-list-item-title>
                      </v-chip>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      !-->
    </v-row>
    
    <v-parallax
      dark
      src="/cosmic-background-1.jpg"
    >
    <v-row
      align="center"
      justify="center"
      >
      <v-col class="text-center mt-8 mb-8" cols="12">
          <h2 class="display-1 font-weight-light">{{ find_me.title }}</h2>
          <v-btn icon v-for="f in find_me.items" :key="f.name" dark :href="f.href" target="_blank">
            <v-icon>{{ f.icon }}</v-icon>
          </v-btn>
      </v-col>
      </v-row>
     </v-parallax>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {},
  data: () => ({
    "title":"svtr.dev",
    "subtitle":"A currently very empty site.",
    "skillset": {
      "title":"This site is still being worked on",
      "sections":[
        {
          "title":"System Administration",
          "icon":"mdi-server",
          "items":[
            {
              "name":"Linux",
              "progress":90
            },
            {
              "name":"Networking",
              "progress":80
            },
            {
              "name":"Apache Kafka",
              "progress":80
            },
            {
              "name":"MySQL",
              "progress":30
            }
          ]
        },
        {
          "title":"Development",
          "icon":"mdi-code-braces",
          "items":[
            {
              "name":"Go",
              "progress":90
            },
            {
              "name":"Javascript",
              "progress":80
            },
            {
              "name":"Bash",
              "progress":80
            },
            {
              "name":"Vue.js",
              "progress":70
            },
            {
              "name":"Python",
              "progress":40
            }
          ]
        },
        {
          "title":"Deployment and Automation",
          "icon":"mdi-cog-sync",
          "items":[
            {
              "name":"Ansible",
              "progress":90
            },
            {
              "name":"Terraform",
              "progress":80
            },
            {
              "name":"Docker",
              "progress":90
            },
            {
              "name":"Kubernetes",
              "progress":70
            },
            {
              "name":"Gitlab-ci",
              "progress":80
            }
          ]
        },
        {
          "title":"Monitoring Tools",
          "icon":"mdi-chart-bell-curve",
          "items":[
            {
              "name":"Prometheus",
              "progress":95
            },
            {
              "name":"Grafana",
              "progress":95
            },
            {
              "name":"Zabbix",
              "progress":80
            },
            {
              "name":"ElasticSearch",
              "progress":70
            },
            {
              "name":"InfluxDB",
              "progress":70
            }
          ]
        }
      ]
    },
    "find_me": {
      "title":"Find Me",
      "items":[
        {
          "name":"LinkedIn",
          "icon":"mdi-linkedin",
          "href":"https://www.linkedin.com/in/sebvautour"
        },
        {
          "name":"Github",
          "icon":"mdi-github",
          "href":"https://github.com/sebvautour"
        },
        {
          "name":"Email",
          "icon":"mdi-email-outline",
          "href":"mailto:seb.vautour@hotmail.com"
        },
      ]
    }
  })
}
</script>

<style>
html,
.bg-dark,
body {
    margin: 0;
    padding: 0;
    background-color: #EBEDEF;
}

.accent-color {
  color: #2C3E50;
}


.bg-accent-secondary-color {
  background-color: #DAF7A6;
}
</style> 